const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA5LjQxNDIxTDQuNzA3MTEgMTYuNzA3MUwzLjI5Mjg5IDE1LjI5MjlMMTIgNi41ODU3OEwyMC43MDcxIDE1LjI5MjlMMTkuMjkyOSAxNi43MDcxTDEyIDkuNDE0MjFaIi8+Cjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=arrow_up-5beeb7c1.mjs.map
